<template>
  <div>
    <el-dialog :close-on-click-modal="false" title="套餐管理" :visible.sync="miVisible" width="800px"
               :before-close="closeEvent">
      <div class="mi-dv">
        <div class="mid-left">
          <div v-for="(item,index) in miNames" class="mid-left-sp" :class="{spanIndex:index==spanIndex}"
               @click="setName(index,item.memberItems)">
            <div>
              <span class="tclx2"> {{item.ascriptionName}}</span>
              <span v-if="item.miType==0" class="tclx">(套餐包)</span>
              <span v-if="item.miType==1" class="tclx">(充续卡)</span>
              <span v-if="item.miType==3" class="tclx">(单项)</span>
              <span v-if="item.miType==4" class="tclx">(月卡)</span>
              <span v-if="item.miType==5" class="tclx">(季卡)</span>
              <span v-if="item.miType==6" class="tclx">(年卡)</span>
            </div>
              <div class="tclx1">{{item.deptName}}</div>
          </div>
        </div>
        <div class="mitems-right">
          <div class="mitems-right1">
            <div class="mi-item-ii" v-for="item in memberItems">
              <div class="mi-con" @click="toMemberItem(item)">
                <span class="mci-name">{{item.itemName}}</span>
                <span class="mci-price">余 {{item.total-item.uses}} 次</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="tcItem.itemName" :visible.sync="numVisible" width="300px">
      <div style="margin: 10px">
        <span style="margin-right: 8px">数量:</span>
        <el-input-number v-model="tcNum" :min="1" :max="maxNum" size="mini"></el-input-number>
      </div>
      <div style="height: 40px">
        <el-button size="small" type="primary" style="float: right" @click="setMemberItem">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        spanIndex: 0,
        miNames: [],
        memberItems: [],
        numVisible: false,
        tcNum: 1,
        maxNum: '',
        tcItem: {},
      }
    },
    props: {
      miVisible: Boolean,
      memberId: String
    },
    created() {
      this.getMemberItems()
      const that = this;
      document.onkeydown = function (event) {
        let key = window.event.keyCode || event.which; // 兼容处理
        if (key == 13) { // 回车键的keyCode为13
          that.setMemberItem();
        }
      };
    },
    beforeDestroy() {
      // 清除事件监听以避免内存泄漏
      document.onkeydown = null;
    },
    methods: {
      //获取用户套餐项目
      async getMemberItems() {
        let res = await this.$get("/sw/getSwMemberItems", {memberId: this.memberId});
        this.miNames = res.names
        if (this.miNames.length > 0) {
          this.memberItems = this.miNames[this.spanIndex].memberItems
        }
      },
      setName(index, memberItems) {
        this.spanIndex = index
        this.memberItems = memberItems
      },
      closeEvent() {
        this.$emit('closeMI')
      },
      toMemberItem(item) {
        this.tcItem = item
        this.maxNum = item.total - item.uses
        this.numVisible = true
      },

      setMemberItem() {
        if (!this.tcItem || !this.tcItem.id || !this.tcNum) {
          return;
        }
        let data = {
          tcNum: this.tcNum,
          item: this.tcItem,
        }
        this.$emit('setMemberItem', data)
      },
    }
  }
</script>
<style lang="scss">
  .mi-dv {
    display: flex;
    flex-direction: row;
    height: 380px;
  }

  .mid-left {
    width: 35%;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    height: 380px;
    border-right: #EEEEEE solid 1px;
  }

  .mid-left-sp {
    cursor: pointer;
    margin-bottom: 5px;
    border-bottom: #EEEEEE solid 1px;
    display: flex;
    flex-direction: column;
    padding-left: 2px;
  }

  .mid-left .spanIndex {
    border-right: #ee0a24 solid 3px;
  }

  .mitems-right {
    width: 65%;
  }
  .mitems-right1 {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .mitems-right1 .mi-item-ii {
    margin:0 5px 10px 5px;
    width: calc(100%  / 4); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
    min-width: calc(100%/ 4);
    max-width: calc(100%/ 4);
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
    box-sizing: border-box;
  }

  .mi-con {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    text-align: center;
    border: #EEEEEE solid 1px;
    padding: 5px 0;
  }

  .mc-img {
    width: 100%;
    height: 78px;
    border-radius: 3px;
  }

  .mci-name {
    margin-top: 3px;
    line-height: 16px;
    margin-left: 5px;
    font-size: 10px;
    margin-bottom: 5px;
  }

  .mci-price {
    line-height: 16px;
    margin-left: 5px;
    font-size: 10px;
  }

  .tclx {
    color: #919191;
    font-size: 10px;
    margin-left: 5px;

  }
  .tclx1 {
    color: #919191;
    font-size: 10px;
    margin: 5px 0;
  }
  .tclx2 {
    color: #ff4d51;
  }
</style>
